import targetAnalysisByOrg from './targetAnalysisByOrg';
import targetAnalysisByTarget from './targetAnalysisByTarget';
import targetAnalysisByOptions from './targetAnalysisByOptions';
import targetAnalysisBySwot from './targetAnalysisBySwot';

export default {
    targetAnalysisByOrg,
    targetAnalysisByTarget,
    targetAnalysisByOptions,
    targetAnalysisBySwot
}